import { isValidEmail, isValidPhone } from "@/config/sellerProfile/storeInfoCompleteness";

export const STORE_LOCATIONS_SECTION_ID = "store-locations-pickup-points";

export const HOURS_DAY_KEYS = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
    "publicHolidays",
];

const WEEKDAY_KEYS = ["monday", "tuesday", "wednesday", "thursday", "friday"];

export function emptyStoreLocationsPayload() {
    return {
        onlineOnly: false,
        locations: [],
        locationCount: 0,
        meta: {
            page: 1,
            perPage: 10,
            total: 0,
        },
    };
}

export function emptyHours() {
    return Object.fromEntries(HOURS_DAY_KEYS.map((day) => [day, { open: false, slots: [] }]));
}

export function defaultNewHours() {
    const hours = emptyHours();

    WEEKDAY_KEYS.forEach((day) => {
        hours[day] = { open: true, slots: [{ from: "09:00", to: "17:00" }] };
    });

    return hours;
}

export function cloneHours(raw) {
    const hours = emptyHours();

    HOURS_DAY_KEYS.forEach((day) => {
        const src = raw?.[day] || {};
        const open = Boolean(src.open);
        const slots = open
            ? (src.slots || []).slice(0, 2).map((slot) => ({
                  from: slot.from || "09:00",
                  to: slot.to || "17:00",
              }))
            : [];

        hours[day] = {
            open,
            slots: open && slots.length === 0 ? [{ from: "09:00", to: "17:00" }] : slots,
        };
    });

    return hours;
}

export function hoursFromLocation(location) {
    if (location?.hoursParsed && location.hours) {
        return cloneHours(location.hours);
    }

    return emptyHours();
}

export function emptyLocationForm() {
    return {
        name: "",
        address: "",
        phone: "",
        email: "",
        city: "",
        cityId: null,
        lat: null,
        lng: null,
        clickAndCollect: false,
        dropOff: false,
        inStoreStock: false,
        hours: emptyHours(),
    };
}

export function locationToForm(location) {
    return {
        name: String(location?.name || ""),
        address: String(location?.address || ""),
        phone: String(location?.phone || ""),
        email: String(location?.email || ""),
        city: String(location?.city || ""),
        cityId: location?.cityId ?? null,
        lat: Number.isFinite(location?.lat) ? location.lat : null,
        lng: Number.isFinite(location?.lng) ? location.lng : null,
        clickAndCollect: Boolean(location?.clickAndCollect),
        dropOff: Boolean(location?.dropOff),
        inStoreStock: Boolean(location?.inStoreStock),
        hours: hoursFromLocation(location),
    };
}

export function locationHasPin(location) {
    return Number.isFinite(location?.lat) && Number.isFinite(location?.lng);
}

export function locationFormComplete(form) {
    return (
        String(form?.name || "").trim() !== "" &&
        String(form?.address || "").trim() !== "" &&
        isValidPhone(form?.phone) &&
        isValidEmail(form?.email)
    );
}

export function emptyStoreLocations() {
    return {
        [STORE_LOCATIONS_SECTION_ID]: {
            payload: emptyStoreLocationsPayload(),
            isComplete: false,
        },
    };
}
